import React from 'react';
import usePricingUsage from './usageStore';
import { Meter, PLAN_USAGE_PATH } from './PricingBits';
import { receptionistMeters, receptionistPriceLine, receptionistState, upgradeIncludes, overageLine } from './usageRules';
import { PRICING_V2_VISIBLE } from '../../config/featureFlags';
import { isOwnerHere } from '../permissions/access';
import { hapticTick } from '../../_utils/haptics';
import './planUsage.css';

/**
 * The receptionist's month on its own settings screen: minutes and replies
 * against the allowance, pay as you go to the owner's limit, and the way to
 * Plan & billing (trial, add it, the limit). Off: what it includes instead.
 * Renders nothing until usage is known, or if the API has no plan.
 */
export default function ReceptionistAllowance({ history, className = '', wrap }) {
    const out = Body({ history, className });
    if (!out) return null;
    return wrap ? wrap(out) : out;
}

function Body({ history, className }) {
    const { usage } = usePricingUsage({ enabled: PRICING_V2_VISIBLE });
    if (!PRICING_V2_VISIBLE || !usage || !usage.plan) return null;
    const owner = isOwnerHere();
    const go = () => { hapticTick(); if (history) history.push(PLAN_USAGE_PATH); };

    const rs = receptionistState(usage);
    if (rs.state === 'legacy') return null;
    if (rs.state === 'trial') {
        return (
            <div className={`pu-card pu-rec ${className}`}>
                <div className="pu-meters">
                    <Meter label="Trial minutes" m={rs.trial.minutes} unit="minutes" />
                    <Meter label="Trial replies" m={rs.trial.replies} unit="replies" />
                </div>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span className="pu-sub">Free trial. It stops on its own unless you add it.</span>
                    {owner && <button type="button" className="pu-link" onClick={go}>Keep it</button>}
                </div>
            </div>
        );
    }
    if (rs.state !== 'on') {
        const inc = upgradeIncludes(usage);
        const price = receptionistPriceLine(usage, { step: true });
        return (
            <div className={`pu-card pu-rec ${className}`}>
                <b>The AI receptionist</b>
                <p className="pu-sub">{inc.minutes} call minutes and {inc.replies} message replies a month, and a phone number.{price ? ` ${price}.` : ''}{rs.trial.available ? ` Try it free for ${rs.trial.days} days.` : ''}</p>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}>
                    {owner && <button type="button" className="pu-primary" onClick={go}>{rs.trial.available ? 'Try it free' : 'Add it'}</button>}
                </div>
            </div>
        );
    }

    const r = receptionistMeters(usage);
    return (
        <div className={`pu-card pu-rec ${className}`}>
            <div className="pu-meters">
                <Meter label="Call minutes this month" m={r.minutes} unit="minutes" />
                <Meter label="Message replies this month" m={r.replies} unit="replies" />
            </div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
                <span className="pu-sub">{rs.overage.capReached ? 'It’s reached your monthly limit and is taking messages until the 1st.' : overageLine(usage)}</span>
                {owner && <button type="button" className="pu-link" onClick={go}>Plan &amp; billing</button>}
            </div>
        </div>
    );
}
